import React, { Component } from 'react';

import { VideoStyle, VideoContain, Poster } from './styles';

class Video extends Component {
  state = {
    showVideo: this.props.playVideo || false,
  }

  render() {
    const { url, poster, noFrame, autoplay } = this.props;
    const { showVideo } = this.state;

    return noFrame ? (
      <>
        {showVideo ? (
          <VideoStyle
            src={url}
            poster={poster}
            autoPlay={autoplay}
            controls
            controlsList="nodownload"
          />
        ) : (
          <Poster onClick={() => this.setState({ showVideo: true })}>
            <img src={poster} alt="Quickpage Video" />
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none">
              <circle cx="40" cy="40" r="40" fill="#000" fillOpacity="0.6"></circle>
              <path
                fill="#E53E3E"
                d="M51.5 37.258c2 1.155 2 4.042 0 5.197l-15 8.66c-2 1.154-4.5-.289-4.5-2.598v-17.32c0-2.31 2.5-3.754 4.5-2.599l15 8.66z"
              ></path>
            </svg>
          </Poster>
        )}
      </>
    ) : (
      <VideoContain>
        {showVideo ? (
          <VideoStyle
            src={url}
            poster={poster}
            autoPlay={autoplay}
            controls
            controlsList="nodownload"
          />
        ) : (
          <Poster onClick={() => this.setState({ showVideo: true })}>
            <img src={poster} alt="Quickpage Video" />
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none">
              <circle cx="40" cy="40" r="40" fill="#000" fillOpacity="0.6"></circle>
              <path
                fill="#E53E3E"
                d="M51.5 37.258c2 1.155 2 4.042 0 5.197l-15 8.66c-2 1.154-4.5-.289-4.5-2.598v-17.32c0-2.31 2.5-3.754 4.5-2.599l15 8.66z"
              ></path>
            </svg>
          </Poster>
        )}
      </VideoContain>
    )
  }
}

export default Video;
